import { Link } from "react-router-dom";

export default function BlogMarketplace() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-950">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-5 py-12 sm:px-6 lg:py-16">
          <p className="text-xs font-semibold uppercase tracking-[3px] text-cyan-700">
            AbroadJacks Blog
          </p>
          <h1 className="mt-3 max-w-4xl text-3xl font-semibold leading-tight text-slate-950 md:text-5xl">
            Why a study abroad consultancy marketplace helps students make better decisions
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-7 text-slate-600">
            Choosing the right study abroad consultant can shape your university admission journey, visa process, and scholarship opportunities. AbroadJacks gives students one place to discover, compare, and contact consultancies with more context.
          </p>
          <div className="mt-6 flex flex-wrap gap-2 text-xs font-semibold text-slate-600">
            <span className="rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5">Marketplace guide</span>
            <span className="rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5">Student decisions</span>
            <span className="rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5">Consultancy comparison</span>
          </div>
        </div>
      </section>

      <article className="mx-auto max-w-5xl px-5 py-10 sm:px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_280px]">
          <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm md:p-8">
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">
            The problem with searching consultancies one by one
              </h2>
              <p className="leading-7 text-slate-700">
            Students usually spend weeks moving between social media pages,
            websites, and referrals. Information is scattered, difficult to
            compare, and often outdated. This makes it hard to shortlist the
            right consultancy based on destination, budget, and course goals.
              </p>
            </section>

            <section className="mt-8 space-y-4">
              <h2 className="text-2xl font-semibold">
            How AbroadJacks works as a marketplace
              </h2>
              <p className="leading-7 text-slate-700">
            AbroadJacks brings verified consultancy profiles, key destination
            strengths, and active student offers into one platform. Instead of
            guessing, students can compare options side by side and contact
            consultancies directly.
              </p>
              <ul className="grid gap-2 text-sm text-slate-700 sm:grid-cols-2">
            <li>Browse multiple consultancies in one dashboard.</li>
            <li>View active offers and scholarship-style promotions.</li>
            <li>Shortlist based on country and program preferences.</li>
            <li>Connect directly via email, website, map, or phone.</li>
              </ul>
            </section>

            <section className="mt-8 space-y-4">
              <h2 className="text-2xl font-semibold">
            Benefits for students planning overseas education
              </h2>
              <p className="leading-7 text-slate-700">
            A marketplace model gives students clarity and speed. You can
            quickly narrow down options, compare guidance quality, and choose a
            consultancy that aligns with your goals for admissions, financial
            planning, and visa timelines.
              </p>
            </section>
          </div>

          <aside className="h-max rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
            <p className="text-sm font-semibold text-slate-950">Start with better shortlisting</p>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              Explore listings by destination, city, service, and trust signals before contacting a consultancy.
            </p>
            <div className="mt-5 grid gap-3">
            <Link
              to="/consultancies"
                className="rounded-lg bg-slate-950 px-4 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Explore Consultancies
            </Link>
            <Link
              to="/register"
                className="rounded-lg border border-slate-300 px-4 py-2.5 text-center text-sm font-semibold text-slate-900 transition hover:bg-slate-50"
            >
              Create Free Account
            </Link>
            </div>
          </aside>
          </div>
      </article>
    </main>
  );
}
